const MIN_DELAY_MS = 1_000;
const MAX_DELAY_MS = 5_000;

/** Idle scans back off; new facts and active interaction restore fast delivery. */
export function createRealtimeVoiceResponsePollBackoff() {
  let delayMs = 0;
  return {
    next(active: boolean) {
      delayMs = active
        ? MIN_DELAY_MS
        : Math.min(MAX_DELAY_MS, Math.max(MIN_DELAY_MS, delayMs * 2));
      return delayMs;
    },
  };
}
